





















import Vue, { PropType } from "vue";
import { Project } from "@/types";
import { isFinishedLock } from "@/util/project-style";

export default Vue.extend({
  props: {
    value: {
      type: Object as PropType<Project>
    },
    autofocus: {
      type: String,
      default: ""
    }
  },

  data() {
    // The CRM's Project::DESCRIPTION_MAX_LENGTH: what still fits the Newbase sync's Camunda string.
    return { maxLength: 3500 };
  },

  computed: {
    locked(): boolean {
      return isFinishedLock(this.value);
    }
  }
});
